import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";

export const updateOrder = async (order, whoToSendUpdateEmail, updatedAt, errorMessage, successMessage) => {
    const response = await HttpClient.safePost(`/api/transactions/system/updateOrder?updatedAt=${updatedAt}`, {
        order,
        whoToSendUpdateEmail
    });

    if (response?.error) {
        message.error(new StringBuilder(errorMessage, "|").append(response.error).toString());
    } else {
        if (successMessage) {
            message.success(successMessage);
        }
    }

    return response;
};

export const changeOrderStatus = async (order, status, toRemove) => {
    const changeStatusRes = await HttpClient.post(`/api/orders/system/${order.eventId}/changeStatus/${status}`, {
        remove: toRemove,
        updatedAt: order.updatedAt
    });

    if (changeStatusRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת שינוי סטאטוס ההזמנה").append(`(${changeStatusRes.error})`).toString()
        );
    } else {
        message.success("סטאטוס ההזמנה שונה בהצלחה");
    }

    return changeStatusRes;
};

export const cancelSystemOrder = async order => {
    const canceledOrder = await HttpClient.post(
        `/api/orders/system/${order.eventId}/cancel?updatedAt=${order.updatedAt}`
    );

    if (canceledOrder.error) {
        message.error(new StringBuilder("שגיאה בעת ביטול ההזמנה").append(`(${canceledOrder.error})`).toString());
    } else {
        message.success("ההזמנה בוטלה בהצלחה");
    }
};

export const createOrderIssueLog = async issueData => {
    const response = await HttpClient.safePost(`/api/orders/system/createIssueLog`, issueData);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה ביצירת דיווח תקלה").append(`(${response.error})`).toString());
    } else {
        message.success("דיווח התקלה נוסף בהצלחה");
    }

    return response;
};

export const updateOrderIssueLog = async issueData => {
    const response = await HttpClient.safePut(`/api/orders/system/updateIssueLog`, issueData);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעדכון תקלה").append(`(${response.error})`).toString());
    } else {
        message.success("התקלה עודכנה בהצלחה");
    }

    return response;
};

export const sendReminderToProvider = async order => {
    const response = await HttpClient.post(`/api/orders/system/${order.eventId}/sendReminderToProvider`);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעת שליחת תזכורת לספק").append(`(${response.error})`).toString());
    } else {
        message.success("התזכורת נשלחה לספק בהצלחה");
    }

    return response;
};

export const reviewDecline = async order => {
    const response = await HttpClient.post(`/api/orders/system/${order.eventId}/reviewDecline`);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעת טיפול בהזמנה שנדחתה").append(`(${response.error})`).toString());
    } else {
        message.success("ההזמנה שנדחתה טופלה בהצלחה");
    }
};

export const reviewBadRating = async order => {
    const response = await HttpClient.post(`/api/orders/system/${order.eventId}/reviewBadRating`);

    if (response?.error) {
        message.error(new StringBuilder("שגיאה בעת טיפול בדירוג השלילי").append(`(${response.error})`).toString());
    } else {
        message.success("הדירוג השלילי טופל בהצלחה");
    }

    return response;
};
